:host {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  --loading-color: var(--ion-color-medium);
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    og-logo {
      max-width: 44px;
      --logo-color: var(--loading-color);
    }
    > span {
      margin-top: 12px;
      max-width: 360px;
      padding: 16px;
      text-align: center;
    }
  }
}
